import React from 'react';
import styled from 'styled-components';
import { LabelValue } from '@warehouse/shared/ui';
import { BrokerJob } from '../../core';

interface JobDetailPanelProps {
	job: BrokerJob;
}

const Wrapper = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.light.background,
	borderTop: `1px solid ${theme.palette.light.backgroundAlt}`,
	boxSizing: 'border-box',
	padding: `${theme.spacing(1.75)} ${theme.spacing(2.5)} ${theme.spacing(1.75)} ${theme.spacing(5.5)}`,
	width: '100%',
}));

const FieldRow = styled('div')(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(4),
	paddingTop: theme.spacing(1),
}));

export function JobDetailPanel({ job }: JobDetailPanelProps) {

	return (
		<Wrapper>
			<LabelValue label="Trace" value={job.jobId ?? '--'} isCopyable />

			<FieldRow>
				<LabelValue label="Triggered By" value={job.triggeredByDisplayName} />
				<LabelValue label="Version" value={job.serviceVersion} />
			</FieldRow>

			{ job.error && job.status === "FAILED" && (
				<FieldRow>
					<LabelValue label="Error" value={job.error} wrap />
				</FieldRow>
			)}
		</Wrapper>
	);
}
